const isServer = process.env.VUE_ENV === 'server'

module.exports = (accept, ua) => {
  if (isServer) {
    if (accept) {
      if (accept.includes('image/webp')) return true
    }
  } else if (!ua) {
    ua = navigator.userAgent

    try {
      const tryWebpDom =
        document
          .createElement('canvas')
          .toDataURL('image/webp', 0.5)
          .indexOf('data:image/webp') === 0
      if (tryWebpDom) {
        return true
      }
    } catch (e) {
      console.log('tryWebpDom error:', e)
    }
  }

  if (ua) {
    const isIos = /(iPhone|iPad|iPod|iOS)/i.test(ua)
    const isAndroid = /(Android)/i.test(ua.toLowerCase())
    const [, version = 0] = ua.match(/os\s+(\d+)/i) || []
    // console.log(`isIos`, isIos)
    // console.log(`isAndroid`, isAndroid)
    // console.log(`version`, version)
    // console.log(`isIos && version >= 14`, isIos && version >= 14)
    // console.log(
    //   `((isIos && version >= 14) || isAndroid) `,
    //   (isIos && version >= 14) || isAndroid
    // )
    // https://caniuse.com/webp
    if ((isIos && version >= 14) || isAndroid) return true
  }
  return false
}
